<cx-icon [type]="iconType.SPINNER"></cx-icon>
